// AUTOGENERATED FILE
// source: scripts/generate-product-types-templates.ts

import React from 'react'
import { ReactComponent as TemplateSVG } from '../../../../../assets/product-templates/svg/two-pieces-tray-box.svg'

export const TwoPiecesTrayBoxTemplate = (
  props: React.SVGProps<SVGSVGElement>
) => {
  return <TemplateSVG {...props} />
}
